import { css } from 'styled-components';

import { resetBrowserButton } from '../../../Button/styles';
import { resetBrowserAnchor } from '../../../Anchor/styles';

import { dropdownTokens } from '../../../../tokens/components/Dropdown/tokens';

const styles = css<{ hover?: boolean; disabled?: boolean; active?: boolean }>`
  ${resetBrowserButton}
  ${resetBrowserAnchor}

  align-items: baseline;
  color: ${dropdownTokens.ItemFontColorBaseDefault};
  cursor: pointer;
  display: flex;
  font-size: ${dropdownTokens.ItemFontSizeBaseDefault};
  font-weight: ${dropdownTokens.ItemFontWeightBaseDefault};
  line-height: ${dropdownTokens.ItemFontLeadingBaseDefault};
  justify-content: space-between;
  padding: ${({ theme }) =>
    theme.mobile
      ? `${dropdownTokens.ItemSpacingVerticalBaseDefaultMobile} ${dropdownTokens.ItemSpacingHorizontalBaseDefault}`
      : `${dropdownTokens.ItemSpacingVerticalBaseDefaultDesktop} ${dropdownTokens.ItemSpacingHorizontalBaseDefault}`};
  text-align: left;
  white-space: normal;
  width: 100%;

  &:hover,
  &:focus-visible {
    color: ${dropdownTokens.ItemFontColorBaseHover};

    ${({ theme }) =>
      theme.hover &&
      !theme.disabled &&
      css`
        background-color: ${dropdownTokens.ItemBackgroundColorBaseHover};
        box-shadow: none;
      `}
  }

  &:focus-visible {
    outline: ${dropdownTokens.ItemOutlineStrokeBaseKeyboardFocus} ${dropdownTokens.ItemOutlineColorBaseKeyboardFocus};
    outline-offset: ${dropdownTokens.ItemOutlineOffsetBaseKeyboardFocus};
  }

  ${({ theme }) =>
    theme.active &&
    !theme.disabled &&
    css`
      color: ${dropdownTokens.ItemFontColorBaseSelected};
      background-color: ${dropdownTokens.ItemBackgroundColorBaseKeyboardFocus};
      font-weight: ${dropdownTokens.ItemFontWeightBaseActive};
    `}

  ${({ theme }) =>
    theme.disabled &&
    css`
      background-color: none;
      color: ${dropdownTokens.ItemFontColorBaseDisabled};
      cursor: not-allowed;
      pointer-events: none;
    `}

  label {
    outline: 0;
    cursor: inherit;
  }

  .ink-control {
    width: 100%;

    &--checkbox {
      padding-top: 0;

      &--label {
        cursor: pointer;
      }
    }
  }

  // Selectable table color overriding
  tr[class*='selected'] a${'&'}, tr[class*='selected']:hover a${'&'} {
    color: ${dropdownTokens.ItemFontColorBaseDefault};

    &:hover {
      color: ${dropdownTokens.ItemFontColorBaseHover};
    }
  }
`;

export default styles;
